// See: https://usehooks-ts.com/react-hook/use-local-storage
import { useEffect } from "react";
import { useLocalStorage } from "../useLocalStorage";
// See: https://usehooks-ts.com/react-hook/use-media-query
import { useMediaQuery } from "../useMediaQuery";
// See: https://usehooks-ts.com/react-hook/use-update-effect

const COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";

interface UseDarkModeOutput {
  isDarkMode: boolean;
  toggle: () => void;
  enable: () => void;
  disable: () => void;
}

function useDarkMode(defaultValue?: boolean): UseDarkModeOutput {
  const isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
  const [isDarkMode, setDarkMode] = useLocalStorage<boolean>("darkMode", defaultValue ?? isDarkOS ?? false);

  // Update darkMode if os prefers changes
  useEffect(() => {
    setDarkMode(isDarkOS);
  }, [isDarkOS]);

  return {
    isDarkMode: isDarkMode,
    toggle: () => {
      setDarkMode((prev) => !prev);
    },
    enable: () => {
      setDarkMode(true);
    },
    disable: () => {
      setDarkMode(false);
    },
  };
}

export default useDarkMode;
